import { Sparkles, Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { SITE } from "../../lib/content";

export default function DemoClass() {
  return (
    <section data-testid="demo-section" className="bg-flame text-white py-20 lg:py-28 relative overflow-hidden noise">
      <div className="relative z-10 max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <div className="flex items-center gap-2 text-white/80 text-xs uppercase tracking-[0.25em] font-semibold mb-5">
            <Sparkles className="h-4 w-4" /> Free Demo Class Available
          </div>
          <h2 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Try a class, free.<br />Then decide.
          </h2>
          <p className="mt-5 max-w-xl text-white/85 text-lg">
            Experience our concept-first teaching before you enrol. Book a free demo class for any
            subject — no strings attached.
          </p>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3">
          <a
            href={`tel:${SITE.phoneIntl}`}
            data-testid="demo-call-button"
            className="inline-flex items-center justify-center gap-2 bg-ink text-white font-semibold px-7 py-4 rounded-full hover:bg-white hover:text-ink transition-colors duration-300"
          >
            <Phone className="h-4 w-4" /> Call to Book Demo
          </a>
          <a
            href={`https://wa.me/${SITE.whatsapp}?text=Hi%2C%20I'd%20like%20to%20book%20a%20free%20demo%20class.`}
            target="_blank"
            rel="noreferrer"
            data-testid="demo-whatsapp-button"
            className="inline-flex items-center justify-center gap-2 bg-white text-ink font-semibold px-7 py-4 rounded-full hover:bg-ink hover:text-white transition-colors duration-300"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
}
